<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <img class="svg-sprite" id="svg-sprite" src="img/icons/icons_sprite.svg" alt="svg-sprite">
    <notifications></notifications>

    <side-bar
      :active-color="sidebarBackground"
      :data-background-color="sidebarBackgroundColor"
      :logo="logoURL"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Оплата',
            subTitle: paymentsStatusLabel,
            subTitleColor: paymentsStatusColor,
            icon: 'payment',
            path: '/payments'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Счетчики',
            subTitle: countersStatusLabel,
            subTitleColor: countersStatusColor,
            icon: 'counters',
            path: '/counters'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Заявки',
            subTitle: appealsStatusLabel,
            subTitleColor: appealsStatusColor,
            icon: 'appeals',
            path: '/appeals'
          }"
        />
        <sidebar-item
          :link="{ name: 'Новости', icon: 'news', path: '/news' }"
        />
        <sidebar-item
          :link="{ name: 'Контакты', icon: 'contacts', path: '/contacts' }"
        />
        <mobile-menu
          :profileNameOrg="profileNameOrganization"
          :profileName="profileName"
        >
        </mobile-menu>
        <sidebar-info-block
          v-if="phones.length > 0 && $sidebar.isMinimized" class="hidden-sm">
          <h5 class="title text-align-center text-main-black">
            {{ phonesTitle }}
          </h5>
          <div class="text-align-center">
            <div v-for="(number, i) in phones" :key="i">
              <a
                class="text-grey-1"
                :key="i"
                :href="`tel:${number}`">
                {{ number }}
              </a>
            </div>
          </div>
        </sidebar-info-block>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar
        :profileNameOrg="profileNameOrganization"
        :profileName="profileName"
        @onChangeAccount="changeAccount"
      >
      </top-navbar>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <router-view></router-view>
      </div>
    </div>
    <div v-if="loader" class="main-layout-loader-wrapper">
      <circle-loader :diameter="70" />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import MobileMenu from "./Extra/MobileMenu.vue";
import SidebarInfoBlock from "@/components/SidebarPlugin/SidebarInfoBlock";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import to from "await-to-js";
import { mapGetters } from "vuex";
import TopNavbar from "./TopNavbar.vue";
import CircleLoader from '@/components/Custom/CircleLoader';
import { SlideXRightTransition } from "vue2-transitions";
import config from "@/config";
import colorMixin from '@/layouts/colorMixin';

export default {
  mixins: [colorMixin],
  components: {
    CircleLoader,
    TopNavbar,
    MobileMenu,
    SlideXRightTransition,
    SidebarInfoBlock
  },
  data() {
    return {
      sidebarBackgroundColor: "white",
      sidebarBackground: "color",
      sidebarMini: false,
      sidebarImg: true,
      loader: false
    };
  },
  computed: {
    ...mapGetters([
      'getPersonalAccountInfo',
      'getManageOrganizationInfo',
      'authToken',
      'getUsername'
    ]),

    logoURL() {
      const { logo } = this.getManageOrganizationInfo;
      return logo || null;
    },

    paymentsStatusColor() {
      if (this.getPersonalAccountInfo) {
        const color = this.getPersonalAccountInfo.paymentsStatus.color;
        if (color === 'ff0000') {
          return 'ccc';
        }
        return '999';
      }
      return '999'
    },

    paymentsStatusLabel() {
      if (this.getPersonalAccountInfo) {
        return this.getPersonalAccountInfo.paymentsStatus.value;
      }
      return null;
    },

    countersStatusLabel() {
      if (this.getPersonalAccountInfo) {
        const val = this.getPersonalAccountInfo.countersStatus.value;
        return val && val !== 'показания' ? val : null;
      }
      return null;
    },

    countersStatusColor() {
      if (this.getPersonalAccountInfo) {
        const color = this.getPersonalAccountInfo.countersStatus.color;
        if (color === 'ff0000') {
          return 'ccc';
        }
        return '999';
      }
      return '999'
    },

    appealsStatusLabel() {
      if (this.getPersonalAccountInfo) {
        return this.getPersonalAccountInfo.appealsStatus.value;
      }
      return null;
    },

    appealsStatusColor() {
      if (this.getPersonalAccountInfo) {
        const color = this.getPersonalAccountInfo.appealsStatus.color;
        if (color === 'ff0000') {
          return 'ccc';
        }
        return '999';
      }
      return '999'
    },

    phonesTitle() {
      if (!this.getManageOrganizationInfo.services) {
        return '';
      }
      const { name, comment } = this.getManageOrganizationInfo.services.mainScreenPhone;
      return `${name}${comment ? ` (${comment})` : ''}`;
    },

    phones() {
      if (!this.getManageOrganizationInfo.services) {
        return [];
      }
      return this.getManageOrganizationInfo.services.mainScreenPhone.value.split(',').filter(e => e);
    },

    profileName() {
      if (this.getPersonalAccountInfo) {
        return `${this.getPersonalAccountInfo.apartment.thoroughfare} ${
          this.getPersonalAccountInfo.apartment.premise
        }`;
      }
      return "";
    },

    profileNameOrganization() {
      if (this.getPersonalAccountInfo) {
        return this.getPersonalAccountInfo.personalAccount.manageorganization;
      }
      return "";
    }
  },
  methods: {

    async changeAccount(token) {
      if (this.authToken === token) {
        return;
      }
      const data = {
        key: token,
        username: this.getUsername
      };

      this.loader = true;
      this.$store.commit('AUTH_LOGIN', data);
      await this.loadData();
      this.loader = false;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    async loadData() {
      const userdata = Promise.all([
        this.$store.dispatch("GET_PERSONAL_ACCOUNT_INFO")
      ]);

      const [errorUser] = await to(userdata);
      if (!errorUser)
        Promise.all([
          this.$store.dispatch("GET_PERSONAL_ACCOUNTS"),
          this.$store.dispatch("GET_MANAGE_ORGANIZATION_INFO"),
          this.$store.dispatch("GET_COMPANY_NEWS"),
          this.$store.dispatch("GET_HOME_NEWS"),
          this.$store.dispatch("GET_COUNTERS"),
          this.$store.dispatch("GET_PAYMENTS"),
          this.$store.dispatch("GET_ACCRUALS"),
          this.$store.dispatch("GET_CATEGORIES")
        ]);
    }
  },
  mounted() {
    this.loadData();
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-layout-loader-wrapper {
  width: 100vw;
  height: 100vh;
  background-color: #00000080;
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
